import { getCategoryFromSku } from "./skuCategory";

/**
 * Bake a leg code into a leg-agnostic catalog SKU, producing the full SKU sent to the cart.
 * The input is expected to be the leg-agnostic short SKU as returned by the catalog.
 *
 * Category-aware, because the placeholder layout differs:
 *  - sofa (DL, 11-char short): append placeholder1+2 ("XX") then the leg code.
 *  - bed component (DB, 13-char, placeholders already present): append just the leg code.
 *
 * "No leg" is expressed by passing the placeholder code "X". Non-leg categories, and an empty
 * leg code, return the SKU unchanged.
 */
export const applyLeg = (shortSku: string, legCode: string): string => {
  if (!legCode) return shortSku;

  const category = getCategoryFromSku(shortSku);

  if (category === "sofa") return `${shortSku}XX${legCode}`;
  if (category === "bed") return `${shortSku}${legCode}`;

  return shortSku;
};
